export default __webpack_public_path__ + "static/help@2x-4565cb61d40fe74bcc79b1d3ccea921d.webp";